import { useState } from 'react';
import { IFFFChangeHandlerEvent, IFieldState } from '../../interfaces';
import { isReactChangeEvent } from '../utils/isReactChangeEvent';

const useFieldState = (
  validators: [(field: string) => string] | [],
  normalizer?: (currentValue: string, previousValue: string) => string
): IFieldState => {
  const [value, setValue] = useState('');
  const [previousValue, setPreviousValue] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [lastPostSubmitError, setLastPostSubmitError] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const changeHandler = (event: IFFFChangeHandlerEvent) => {
    if (isReactChangeEvent(event) && event.target) {
      const current = event.target.value;
      const normalizedValue = normalizer ? normalizer(current, value) : current;
      event.preventDefault();
      setPreviousValue(value);
      setValue(normalizedValue);
      setIsTouched(true);
      setErrorMsg(`${validators.map((validator) => `${validator(normalizedValue)} `)}`.trim());
      // eslint-disable-next-line no-param-reassign
      event.target.value = normalizedValue;
    }
  };

  const blurHandler = () => {
    setIsTouched(true);
    setErrorMsg(`${validators.map((validator) => `${validator(value)} `)}`.trim());
  };

  const onSubmit = (error: string) => {
    setErrorMsg(error);
    setLastPostSubmitError(error);
  };

  const reset = () => {
    setValue('');
    setIsTouched(false);
    setErrorMsg('');
    setPreviousValue('');
    setLastPostSubmitError('');
  };

  return {
    value,
    previousValue,
    errorMsg,
    hasError: errorMsg !== '' && isTouched,
    isTouched,
    changeHandler,
    blurHandler,
    reset,
    lastPostSubmitError,
    onSubmit,
  };
};

export default useFieldState;
